"use client";

import { usePathname } from "next/navigation";
import Script from "next/script";
import { useEffect, useState } from "react";
import { useConsent } from "@/lib/consent";
import * as pixel from "../../lib/fbpixel";

// The pixel loads only after the visitor accepts "advertisement" in CookieYes.
export const FacebookPixel = () => {
  const [loaded, setLoaded] = useState(false);
  const consented = useConsent("advertisement");
  const pathname = usePathname();

  useEffect(() => {
    if (!loaded || !consented) return;

    pixel.pageview();
  }, [pathname, loaded, consented]);

  // Withdrawn after load: stop the pixel sending until consent comes back.
  useEffect(() => {
    if (!loaded) return;

    window.fbq("consent", consented ? "grant" : "revoke");
  }, [loaded, consented]);

  if (!consented && !loaded) return null;

  return (
    <div>
      <Script
        id="fb-pixel"
        src="/scripts/pixel.js"
        strategy="afterInteractive"
        onLoad={() => setLoaded(true)}
        data-pixel-id={pixel.FB_PIXEL_ID}
      />
    </div>
  );
};
